(async function(algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, productTemplate, footerTemplate } = algolia;

  // Filters for stock policy
  let stockPolicyFilter = '';

  if (algolia.config.stock_policy === 'deny') {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = 'inventory_quantity > 0';
  } else if (algolia.config.stock_policy === 'continue') {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = 'inventory_available:true OR named_tags.Algolia:Show';
  }

  const index_suffix = await config.index_suffix;

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: 'products',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'products' + index_suffix,
                  query,
                  params: {
                    hitsPerPage: config.products_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    filters: stockPolicyFilter,
                    distinct: algolia.config.show_products,
                    ruleContexts: ['hide-products',"bury-sale"]
                  },
                },
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          templates: {
            header({ html, state }) {
              const resource = translations.products;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const distinct = config.show_products;
              const variantInfo = !distinct && item.objectID !== item.id ? `?variant= ${item.objectID}` : '';
              const itemLink = `${window.Shopify.routes.root}products/${item.handle}/${variantInfo}`;
              const getConversionData = (e, item) => {
                if (!algolia.config.analytics_enabled) return;
                const clickData = {
                  index: item.__autocomplete_indexName,
                  eventName: 'Added to cart',
                  queryID: item.__autocomplete_queryID,
                  objectIDs: [item.objectID],
                };

                /**
                 * Uncomment the following function call to start storing data in
                 * local storage for conversion tracking
                 */
                algolia.saveForConversionTracking(clickData);
              }
              const autocompleteProductPrice = (item, distinct) => {
                  var formatPrice = function formatPrice(value) { return algolia.formatMoney(Number(value) * 100); };
                  if (item.compare_at_price != null){
                    if (item.price < item.compare_at_price) {
                      return html `<del><span class="sr-only">Original Price</span>${formatPrice(item.compare_at_price).replace('.00','')}</del><span class="autocomplete_compare_price"><span class="sr-only">Current Price</span>${formatPrice(item.price).replace('.00','')}</span>`;
                    } else {
                      if (distinct) {
                        var min = item.variants_min_price;
                        var max = item.variants_max_price;
                        if (min !== max) return html `${formatPrice(min).replace('.00','')} - ${formatPrice(max).replace('.00','')}`;
                        else return html `<span class="sr-only">Current Price</span><b>${formatPrice(item.price).replace('.00','')}</b>`;
                      }
                    }
                  } else {
                    return html `<span class="sr-only">Current Price</span><b>${formatPrice(item.price).replace('.00','')}</b>`;
                  }
              }
              return productTemplate({ item, html, components }, distinct, itemLink, getConversionData, autocompleteProductPrice);
            },
            footer({ state, html }){
              const {autocomplete_see_all, products_autocomplete_hits_per_page} = config;
              const showFooter = autocomplete_see_all && state.context.nbProducts > products_autocomplete_hits_per_page
              return showFooter && footerTemplate({ html, state });
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
